const REFERRAL_STORAGE_KEY = "fcr_ref";

export const normalizeReferralCode = (value) =>
  String(value || "").trim().toLowerCase().replace(/[^a-z0-9]/g, "").slice(0, 24);

export const rememberReferralCode = (search = "") => {
  const queryCode = normalizeReferralCode(new URLSearchParams(search).get("ref"));
  let storedCode = "";

  try {
    storedCode = normalizeReferralCode(
      sessionStorage.getItem(REFERRAL_STORAGE_KEY) || localStorage.getItem(REFERRAL_STORAGE_KEY),
    );
    const code = queryCode || storedCode;
    if (code) {
      localStorage.setItem(REFERRAL_STORAGE_KEY, code);
      sessionStorage.setItem(REFERRAL_STORAGE_KEY, code);
    }
    return code;
  } catch (error) {
    return queryCode || storedCode;
  }
};

export const buildAppxCheckoutUrl = (baseUrl, referralCode) => {
  const url = new URL(baseUrl);
  const code = normalizeReferralCode(referralCode);
  if (code) {
    url.searchParams.set("ref", code);
    url.searchParams.set("utm_source", code);
  }
  return url.toString();
};